module.exports = __webpack_public_path__ + "img/brand-cases25.4324f0fe.png";